export default __webpack_public_path__ + "static/media/innovation.1de9598f.svg";